import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { configureStore } from '@reduxjs/toolkit';
import authReducer from './store/authentication/reducer';
import signupReducer from './store/signup/reducer';
import dataReducer from './store/jobOpportunities/reducer';
import { Provider } from 'react-redux';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const store = configureStore({
	reducer: {
		auth: authReducer,
		signup: signupReducer,
		data: dataReducer,
	},
	preloadedState: {
		auth: {
			profile: JSON.parse(localStorage.getItem('cogen_user_profile')),
		},
	},
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
	<React.StrictMode>
		<Provider store={store}>
			<App />
			<ToastContainer />
		</Provider>
	</React.StrictMode>
);
